import React, { useState } from 'react';
import './Topbar.css';
import { TiShoppingCart } from "react-icons/ti";
import { Drawer, Box, Typography, IconButton, List, ListItem, ListItemText, Badge } from '@mui/material';
import { AiOutlineMinusCircle } from 'react-icons/ai';
import CloseIcon from '@mui/icons-material/Close';

function Topbar({ selectedItems, handleRemove, onSearch }) {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <div>
      <div className="topbar-container">
        <h1 className="logo">Microsoft 365</h1>
        <input 
          type="text" 
          placeholder="Search features..." 
          className="search-input" 
          onChange={(e) => onSearch(e.target.value)}  // Update search term in Features.js
        />
        <Badge badgeContent={selectedItems.reduce((sum, item) => sum + item.quantity, 0)} color="secondary">
          <TiShoppingCart 
            className="cart-icon" 
            onClick={() => setDrawerOpen(true)} 
          />
        </Badge>
      </div>

      {/* Shopping Cart Drawer */}
      <Drawer anchor="right" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
        <Box sx={{ width: 300, padding: '10px', position: 'relative' }}>
          <IconButton 
            onClick={() => setDrawerOpen(false)} 
            sx={{ position: 'absolute', top: '10px', right: '10px' }}
          >
            <CloseIcon />
          </IconButton>

          <Typography variant="h6" sx={{ marginBottom: '10px', marginTop: '30px' }}>Selected Features</Typography>
          {selectedItems.length === 0 ? (
            <Typography>No services selected</Typography>
          ) : (
            <List>
              {selectedItems.map((item, idx) => (
                <ListItem key={idx}>
                  {/* Minus button on the left */}
                  <IconButton edge="start" onClick={() => handleRemove(item.title)}>
                    <AiOutlineMinusCircle color="red" />
                  </IconButton>
                  
                  {/* Service name with quantity */}
                  <ListItemText primary={`${item.title} (x${item.quantity})`} />
                </ListItem>
              ))}
            </List>
          )}
        </Box>
      </Drawer>
    </div>
  );
}

export default Topbar;
